/* ==========================================================================
   Donaldson BOFA replacement filter page, V1 — assets/abi-bofa-filter-page.js
   Loaded (defer) by sections/bofa-filter-page.liquid, template product.bofa-filter-v2. Release 2026-11, feature bofa-filter-page.
   Spec: Design Handoffs/BOFA Product Pages/design_handoff_bofa_filter_page_v1/README.md ("Behaviour", "States", "Links").

   What it does, all from the islands the section renders (data-bfp-config, data-bfp-map = the finder mapping,
   data-bfp-products = live prices by SKU) plus assets/abi-bofa-replacing-it.json:
     - the model combobox (name, slug, aliases), the answer card (fits / doesn't fit / alternative / not confirmed / no model);
     - the picked model kept for the visit in sessionStorage["abi-bofa-model"] (?model= on the URL wins; clearing the field
       clears the key); version choices are READ from the finder's key "abi-bofa-versions:<slug>" and never written here;
     - Filter version (only for a stage with several versions): this page / buy / by quote with no price;
     - Complete the set (only for a model this filter fits): per-row Add, and Add the set = ONE /cart/add.js call with one
       line per filter × sets. Only the version the customer chose in the finder, or the stage's standard version, is ever
       added: a stage without one shows its versions as links, a stage with nothing sold online is "by quote", and a stage
       the mapping hasn't confirmed is shown as not confirmed and not counted. The bundle product is never used;
     - "Replacing it": the "no video" sentence only for models the data file covers;
     - Add to cart (one call), the Cart V2 drawer, the quantity math line, the phone sticky add bar;
     - every "Send us a message" link (topic, model once picked, pn, from) and the by-quote links (product + part, no price).
   No phone number, no savings wording. Text goes in through textContent only (never innerHTML).
   `core` (pure functions) is exported for Node tests.
   ========================================================================== */
(function (factory) {
  'use strict';
  var core = factory();
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }
  if (typeof document === 'undefined') return;
  var start = function () {
    var roots = document.querySelectorAll('[data-bfp]');
    for (var i = 0; i < roots.length; i++) core.mount(roots[i]);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(function () {
  'use strict';

  var CART_TIMEOUT = 15000;
  var MAX_OPTIONS = 8;
  var PACK = /\s*\((twin pack|pack of \d+|\d+ pack)\)\s*$/i;
  var STR = {
    remember_none: 'We’ll keep your model for this visit.',
    remember_set: 'Saved for this visit, so other BOFA pages check against the {model} too.',
    none_title: 'Pick your model to check the fit.',
    none_sub_side: 'Or check the list of models on the right.',
    none_sub_below: 'Or check the list of models below.',
    yes_title: 'Yes, it fits the {model}.',
    yes_sub: '{stage}: the standard {role}.',
    yes_sub_single: 'The standard {role}.',
    older_gone: ' This model is no longer made; its filters are still sold.',
    older_phasing: ' This model is being phased out; its filters are still sold.',
    older_plain: ' This is an older model; its filters are still sold.',
    yes_link: 'View the {model}',
    no_title: 'No, this filter doesn’t fit the {model}.',
    no_sub: 'See the filters that do fit it, in the filter finder.',
    no_link: 'Filters for the {model}',
    alt_title: 'This is an alternative for the {model}.',
    alt_std_link: 'The standard version is {sku}',
    alt_std_text: ' The standard version is {sku}.',
    unconf_title: 'We haven’t confirmed the filters for the {model} yet.',
    unconf_sub: 'Send us the model and the part number from the filter’s label, and we’ll check the match before you order.',
    unconf_link: 'Send us a message',
    stage: 'Stage {i} of {n}',
    opt_fits: 'Fits',
    no_match: 'No BOFA model matches. ',
    contact: 'Send us a message',
    count: '{n} models found',
    count_one: '1 model found',
    ver_title: 'Versions of this {role} for the {model}',
    set_title: 'Complete the set for the {model}',
    set_title_none: 'Complete the set',
    set_lead: 'The {model} takes {n} filters. Add the ones you’re replacing, or the whole set as separate cart lines.',
    set_lead_packs: 'The {model} takes {n} filter packs. Add the ones you’re replacing, or the whole set as separate cart lines.',
    set_stage: '{stage} · {role}',
    set_total: '{sets} · {filters} · {total}',
    set_one: '1 set',
    set_many: '{n} sets',
    filters_many: '{n} filters',
    packs_many: '{n} packs',
    add_set: 'Add the set',
    add_sets: 'Add {n} sets',
    by_quote_note: '{label} {sku}: available by quote',
    sold_note: '{label} {sku}: sold separately',
    left_out: 'Not in the set: {list}.',
    left_item: '{name} {sku} (available by quote)',
    left_view: '{name} {sku}',
    left_choose: '{role} (choose a version)',
    left_unconfirmed: '{name} (not confirmed yet)',
    add: 'Add to cart',
    adding: 'Adding…',
    added: 'Added to cart: {qty} × {sku}.',
    added_set: 'Added to cart: {sets} for the {model}, as separate cart lines.',
    add_failed: 'That didn’t go in the cart. Please try again.',
    math: '{qty} × {price} = {total}',
    list_ref: '{label} {price}',
    rep_video: 'Filter-change video: {label}',
    rep_cite: 'Source: {cite}.',
    rep_no_video: 'Donaldson hasn’t published a filter-change video for the {model}.',
    rep_no_model: 'Pick your model to see Donaldson’s filter-change video for it.',
    part_no: ' (Part No: {sku})'
  };

  /* ---------------- pure helpers ---------------- */
  function text(v) { return v == null ? '' : String(v); }
  function trim(v) { return text(v).replace(/^\s+|\s+$/g, ''); }
  function norm(v) { return text(v).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function fill(tpl, vars) {
    return text(tpl).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? String(vars[k]) : ''; });
  }
  function str(key, vars) { return fill(STR[key], vars); }
  function find(list, fn) { for (var i = 0; i < (list ? list.length : 0); i++) if (fn(list[i], i)) return list[i]; return null; }
  function clampInt(v, min, max, fallback) {
    var n = parseInt(text(v).replace(/[^0-9]/g, ''), 10);
    if (isNaN(n)) return fallback;
    return Math.max(min, Math.min(max, n));
  }
  function stripEndPeriod(s) { return trim(s).replace(/\.+$/, ''); }
  function sentence(s) { var t = trim(s); return t ? stripEndPeriod(t) + '.' : ''; }
  /* "Pre-filter" → "pre-filter"; "HEPA filter" and "NOX …" stay */
  function lowerFirst(s) { var r = text(s); return /^[A-Z][a-z]/.test(r) ? r.charAt(0).toLowerCase() + r.slice(1) : r; }
  /* The stage's plain role, from the mapping's own stage name: "DeepPleat DUO pre-filter (twin pack)" → "Pre-filter",
     "Combined HEPA + gas filter, large" → "Combined filter"; anything else keeps its name ("Sponge filter", "Pre-filter bag",
     "Chemical pad filter"), without the pack size. */
  function roleOf(stage) {
    var name = trim(text(stage && stage.name).replace(PACK, ''));
    if (/combined/i.test(name)) return 'Combined filter';
    if (/pre-filter/i.test(name) && !/\b(bag|pad)\b/i.test(name)) return 'Pre-filter';
    return trim(name.replace(/,.*$/, '')) || 'Filter';
  }
  function isPack(name) { return PACK.test(text(name)); }
  function confirmed(stage) { return !!stage && stage.status === 'confirmed'; }

  /* Shopify money format ("${{amount}}" and its variants); tags a shop may wrap around it are dropped. */
  function formatMoney(cents, format) {
    var f = text(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(f);
    var kind = m ? m[1] : 'amount';
    function delim(n, precision, thousands, decimal) {
      var fixed = (Number(n) / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    if (kind === 'amount_no_decimals') value = delim(cents, 0, ',', '.');
    else if (kind === 'amount_with_comma_separator') value = delim(cents, 2, '.', ',');
    else if (kind === 'amount_no_decimals_with_comma_separator') value = delim(cents, 0, '.', ',');
    else if (kind === 'amount_with_apostrophe_separator') value = delim(cents, 2, '’', '.');
    else value = delim(cents, 2, ',', '.');
    return m ? f.replace(m[0], value) : value;
  }

  /* The mapping, indexed. map = the finder JSON { models: [...], filters: {...} }. */
  function indexMap(map) {
    /* no prototype: "?model=constructor" must not resolve to anything */
    var bySlug = Object.create(null);
    var byAlias = Object.create(null);
    var models = (map && map.models) || [];
    models.forEach(function (m) {
      bySlug[m.slug] = m;
      byAlias[norm(m.slug)] = m.slug;
      byAlias[norm(m.name)] = m.slug;
      (m.aliases || []).forEach(function (a) { if (!byAlias[norm(a)]) byAlias[norm(a)] = m.slug; });
    });
    return { models: models, bySlug: bySlug, byAlias: byAlias, filters: (map && map.filters) || {} };
  }
  /* A slug, a name or an alias → the model's slug ('' when unknown). */
  function resolveModel(index, value) {
    var v = trim(value);
    if (!v) return '';
    if (index.bySlug[v]) return v;
    return index.byAlias[norm(v)] || '';
  }
  /* Combobox options: name, slug and aliases match as substrings of the normalised text; models this filter fits first,
     then the rest in directory order; at most `limit`. */
  function matchModels(index, query, fitSlugs, limit) {
    var q = norm(query);
    var fits = {};
    (fitSlugs || []).forEach(function (s, i) { fits[s] = i + 1; });
    var hits = index.models.filter(function (m) {
      if (!q) return true;
      if (norm(m.name).indexOf(q) >= 0 || norm(m.slug).indexOf(q) >= 0) return true;
      return (m.aliases || []).some(function (a) { return norm(a).indexOf(q) >= 0; });
    }).map(function (m, i) { return { m: m, i: i }; });
    hits.sort(function (a, b) {
      var fa = fits[a.m.slug] || 0, fb = fits[b.m.slug] || 0;
      if (!!fa !== !!fb) return fa ? -1 : 1;
      if (fa && fb) return fa - fb;
      if (q) {
        var sa = norm(a.m.name).indexOf(q) === 0 ? 0 : 1, sb = norm(b.m.name).indexOf(q) === 0 ? 0 : 1;
        if (sa !== sb) return sa - sb;
      }
      return a.i - b.i;
    });
    return { total: hits.length, options: hits.slice(0, limit || MAX_OPTIONS).map(function (h) { return { slug: h.m.slug, name: h.m.name, fits: !!fits[h.m.slug] }; }) };
  }
  /* Where this SKU sits in a model: { stage, index, count, version } or null. Only stages the mapping has confirmed are
     counted ("Stage 1 of 2"): a stage that is still "not confirmed" is shown as such, never numbered or counted. */
  function placeOf(model, sku) {
    if (!model) return null;
    var own = find(model.stages, function (s) { return !!find(s.versions, function (x) { return x.sku === sku; }); });
    if (!own) return null;
    var counted = model.stages.filter(function (s) { return confirmed(s) || s === own; });
    return { stage: own, index: counted.indexOf(own), count: counted.length, version: find(own.versions, function (x) { return x.sku === sku; }) };
  }
  /* "Stage 1 of 2", or the component a stage belongs to on a two-unit system ("HTP purge unit"). */
  function stageLabel(model, stage) {
    if (stage && stage.component) return text(stage.component);
    var counted = model.stages.filter(function (s) { return confirmed(s) || s === stage; });
    return str('stage', { i: counted.indexOf(stage) + 1, n: counted.length });
  }
  function olderSentence(fit) {
    if (!fit || !fit.older) return '';
    if (/no longer made/i.test(fit.chip)) return str('older_gone');
    if (/phased out/i.test(fit.chip)) return str('older_phasing');
    return str('older_plain');
  }
  /* The answer card for the picked model. cfg.fits = the server's fit rows; side = lists sit beside the card. */
  function answerFor(cfg, index, slug, side) {
    var model = slug ? index.bySlug[slug] : null;
    if (!model) return { state: 'none', mark: '?', title: str('none_title'), sub: str(side ? 'none_sub_side' : 'none_sub_below'), link: null };
    var fit = find(cfg.fits, function (f) { return f.slug === slug; });
    var name = model.name;
    if (!fit) {
      if (model.status !== 'confirmed') return { state: 'none', mark: '?', title: str('unconf_title', { model: name }), sub: str('unconf_sub'), link: { text: str('unconf_link'), href: null, contact: true } };
      return { state: 'no', mark: '×', title: str('no_title', { model: name }), sub: str('no_sub'), link: { text: str('no_link', { model: name }), href: cfg.finder + '?model=' + encodeURIComponent(slug) } };
    }
    var place = placeOf(model, cfg.sku);
    var unit = fit.units && fit.units[0] ? cfg.products_root + fit.units[0].handle : null;
    if (fit.conditional) {
      var std = place ? find(place.stage.versions, function (v) { return v.standard && v.sku !== cfg.sku; }) : null;
      var sub = sentence(fit.condition);
      var link = null;
      if (std && std.handle) link = { text: str('alt_std_link', { sku: std.sku }), href: cfg.products_root + std.handle };
      else if (std) sub += str('alt_std_text', { sku: std.sku });
      return { state: 'alt', mark: '!', title: str('alt_title', { model: name }), sub: sub, link: link };
    }
    var role = lowerFirst(roleOf(place && place.stage));
    var numbered = place && (place.count > 1 || place.stage.component);
    var line = numbered ? str('yes_sub', { stage: stageLabel(model, place.stage), role: role }) : str('yes_sub_single', { role: role || 'filter' });
    return { state: 'yes', mark: '✓', title: str('yes_title', { model: name }), sub: line + olderSentence(fit), link: unit ? { text: str('yes_link', { model: name }), href: unit } : null };
  }
  /* "Standard combined filter" on stage "Combined filter" → "Standard"; "NOX combined filter" → "NOX". */
  function shortLabel(label, stageName) {
    var stop = {};
    text(stageName).toLowerCase().split(/\s+/).forEach(function (w) {
      var c = w.replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '');
      if (!c) return;
      stop[c] = true;
      c.split('-').forEach(function (p) { if (p) stop[p] = true; });
    });
    var kept = trim(label).split(/\s+/).filter(function (tok) {
      var c = tok.toLowerCase().replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '');
      return c && !stop[c] && c !== 'filter';
    });
    return kept.join(' ') || trim(label);
  }
  /* A version named in a set note: "NOX version", "Clean-room version"; when the short form doesn't read as a qualifier
     (nothing was dropped, or a bracket was cut in half) the version's full name is used as it stands. */
  function noteLabel(label, stageName) {
    var s = shortLabel(label, stageName);
    var balanced = (s.match(/\(/g) || []).length === (s.match(/\)/g) || []).length;
    if (!s || s === trim(label) || !balanced) return trim(label);
    return s + ' version';
  }
  function quoteHref(cfg, index, sku, label) {
    var f = index.filters[sku];
    var title = trim(f && f.title) || trim(label) || sku;
    if (title.indexOf('(Part') < 0) title += str('part_no', { sku: sku });
    return cfg.quote + '?product=' + encodeURIComponent(title) + '&part=' + encodeURIComponent(sku);
  }
  function contactHref(cfg, modelName) {
    return cfg.contact + '?topic=filters' + (modelName ? '&model=' + encodeURIComponent(modelName) : '') + '&pn=' + encodeURIComponent(cfg.sku) + '&from=' + encodeURIComponent(cfg.from);
  }
  /* Filter version rows for the picked model: [] unless this SKU's stage has several versions. */
  function versionRows(cfg, index, products, slug) {
    var model = index.bySlug[slug];
    var place = placeOf(model, cfg.sku);
    if (!place || place.stage.versions.length < 2) return [];
    return place.stage.versions.map(function (v) {
      var p = products[v.sku];
      var here = v.sku === cfg.sku;
      return {
        sku: v.sku, label: v.label, cond: sentence(v.condition), here: here,
        buy: !here && !!p, price: !here && p ? p.price : null, compare_at: !here && p ? p.compare_at : null, href: !here && p ? p.url : null,
        quote: !here && !p, quoteHref: !here && !p ? quoteHref(cfg, index, v.sku, v.label) : null
      };
    });
  }
  /* The set for the picked model: one row per stage. `choices` = the finder's stored version per stage key (read only).
     Returns null unless this filter fits the model and the model has at least two confirmed stages. Row kinds:
       here         this page's filter
       buy          another stage's filter, added by "Add the set": the version the customer chose in the finder, else the
                    stage's standard version. Never any other version: the page doesn't pick one for the customer
       view         the standard version has a product page but can't be ordered online right now: a link, nothing added
       choose       no standard version (two inlet sizes, two grades): links to the versions that have a page
       quote        nothing to buy online in the stage: "Available by quote"
       unconfirmed  the mapping hasn't confirmed this stage for the model: no part number is claimed, it isn't counted */
  function setRows(cfg, index, products, slug, choices) {
    var model = index.bySlug[slug];
    var place = placeOf(model, cfg.sku);
    if (!place || place.count < 2) return null;
    var counted = model.stages.filter(function (s) { return confirmed(s) || s === place.stage; });
    var listed = function (v) { return !!products[v.sku]; };
    var sold = function (v) { var p = products[v.sku]; return !!(p && p.available); };
    function notesFor(stage, shownSku) {
      return stage.versions.filter(function (x) { return x.sku !== shownSku && x.sku !== cfg.sku; }).map(function (x) {
        var label = noteLabel(x.label, stage.name);
        var p = products[x.sku];
        return { text: str(p ? 'sold_note' : 'by_quote_note', { label: label, sku: x.sku }), href: p ? p.url : null };
      });
    }
    function fromProduct(row, v) {
      var p = products[v.sku];
      row.name = v.label; row.sku = v.sku; row.variant_id = p.variant_id; row.price = p.price; row.compare_at = p.compare_at; row.image = p.image; row.spec = p.spec; row.href = p.url;
      return row;
    }
    var rows = model.stages.map(function (stage) {
      var role = roleOf(stage);
      var own = stage === place.stage;
      var row = { kind: '', here: own, buy: false, quote: false, stage: confirmed(stage) || own ? str('set_stage', { stage: stageLabel(model, stage), role: role }) : role, role: role, name: stage.name, sku: '', price: null, compare_at: null, notes: [], links: [] };
      if (own) {
        /* this filter's own versions are the "Filter version" section's job: no note on its row */
        row.kind = 'here'; row.name = place.version.label; row.sku = cfg.sku; row.variant_id = cfg.variant_id; row.price = cfg.price; row.compare_at = cfg.compare_at; row.image = cfg.image; row.spec = cfg.spec; row.buy = !!cfg.available;
        return row;
      }
      if (!confirmed(stage)) { row.kind = 'unconfirmed'; return row; }
      var wanted = choices && typeof choices[stage.key] === 'string' ? choices[stage.key].toUpperCase() : '';
      var std = find(stage.versions, function (x) { return x.standard; });
      var v = find(stage.versions, function (x) { return x.sku === wanted && sold(x); }) || (std && sold(std) ? std : null);
      if (v) { row.kind = 'buy'; row.buy = true; fromProduct(row, v); row.notes = notesFor(stage, v.sku); return row; }
      if (std && listed(std)) { row.kind = 'view'; fromProduct(row, std); row.notes = notesFor(stage, std.sku); return row; }
      var pages = stage.versions.filter(listed);
      if (!std && pages.length) {
        row.kind = 'choose';
        row.links = pages.map(function (x) { return { text: x.label + ' ' + x.sku, href: products[x.sku].url }; });
        row.notes = stage.versions.filter(function (x) { return !listed(x); }).map(function (x) { return { text: str('by_quote_note', { label: noteLabel(x.label, stage.name), sku: x.sku }), href: null }; });
        return row;
      }
      var first = std || stage.versions[0];
      row.kind = 'quote'; row.quote = !!first;
      if (first) { row.name = first.label; row.sku = first.sku; row.quoteHref = quoteHref(cfg, index, first.sku, first.label); row.notes = notesFor(stage, first.sku); }
      return row;
    });
    var lines = rows.filter(function (r) { return r.buy; });
    return {
      model: model, rows: rows, lines: lines, stages: counted.length,
      /* every counted stage is sold as a pack (twin packs on the AD 2000 iQ): say "packs", not "filters" */
      packs: counted.every(function (s) { return isPack(s.name); }),
      perSet: lines.reduce(function (sum, r) { return sum + r.price; }, 0),
      left: rows.filter(function (r) { return !r.buy && !r.here; })
    };
  }
  function leftText(r) {
    if (r.kind === 'unconfirmed') return str('left_unconfirmed', { name: r.name });
    if (r.kind === 'choose') return str('left_choose', { role: r.role });
    if (r.kind === 'view') return str('left_view', { name: r.name, sku: r.sku });
    return str('left_item', { name: r.name, sku: r.sku });
  }
  function setItems(set, sets) { return set.lines.map(function (r) { return { id: r.variant_id, quantity: sets }; }); }
  /* The finder's version choices for a model: { stageKey: SKU } (sessionStorage, JSON). Never written here. */
  function readChoices(storage, prefix, slug) {
    try {
      var raw = storage && storage.getItem(prefix + slug);
      var obj = raw ? JSON.parse(raw) : null;
      return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};
    } catch (e) { return {}; }
  }
  /* "Replacing it" for a model from assets/abi-bofa-replacing-it.json. "Donaldson hasn't published a filter-change video"
     is a claim about Donaldson, so it prints only for a model the file covers (its entry carries no video). A model the
     file doesn't list gets no sentence about videos at all. */
  function replacingFor(data, model) {
    if (!model) return { state: 'pick', none: (data && data._fallback && data._fallback.no_model_text) || str('rep_no_model') };
    var covered = !!data && Object.prototype.hasOwnProperty.call(data, model.slug) && !!data[model.slug] && typeof data[model.slug] === 'object';
    var d = covered ? data[model.slug] : {};
    var hasVideo = !!(d.video && d.video.url);
    var noVideo = fill((data && data._fallback && data._fallback.no_video_text) || STR.rep_no_video, { model: model.name });
    return {
      state: 'model',
      covered: covered,
      video: hasVideo ? { href: d.video.url, title: str('rep_video', { label: d.video.label }) } : null,
      none: covered && !hasVideo ? noVideo : '',
      when: trim(d.guidance),
      cite: d.guidance && d.citation ? str('rep_cite', { cite: stripEndPeriod(d.citation) }) : '',
      manualLabel: trim(d.manual_link_label)
    };
  }

  /* ---------------- DOM ---------------- */
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function readIsland(root, sel) {
    var el = qs(root, sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }
  function show(el, on) { if (el) el.hidden = !on; }
  function setText(el, value) { if (el) el.textContent = text(value); }
  function slot(root, name) { return qs(root, '[data-slot="' + name + '"]'); }
  function sessionStore() { try { return window.sessionStorage; } catch (e) { return null; } }
  function clone(root, name) {
    var tpl = qs(root, 'template[data-bfp-tpl="' + name + '"]');
    return tpl && tpl.content ? tpl.content.firstElementChild.cloneNode(true) : null;
  }

  var cartChain = null;
  function cartUrl() {
    var r = '/';
    try { if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) r = String(window.Shopify.routes.root); } catch (e) { r = '/'; }
    return (r.charAt(r.length - 1) === '/' ? r : r + '/') + 'cart/add.js';
  }
  /* One POST /cart/add.js with items[]; 15 s timeout; requests never overlap. Resolves { key }; rejects { message }. */
  function cartAdd(items) {
    var run = function () {
      return new Promise(function (resolve, reject) {
        if (typeof window.fetch !== 'function') { reject({ message: '' }); return; }
        var done = false;
        var ctrl = null;
        try { ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null; } catch (e) { ctrl = null; }
        var timer = setTimeout(function () {
          if (done) return;
          done = true;
          try { if (ctrl) ctrl.abort(); } catch (e) { /* ignore */ }
          reject({ message: '' });
        }, CART_TIMEOUT);
        var opts = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items }) };
        if (ctrl) opts.signal = ctrl.signal;
        window.fetch(cartUrl(), opts).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, status: r.status, data: data || {} }; });
        }).then(function (res) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          if (!res.ok) { reject({ message: res.status === 422 ? stripEndPeriod(res.data.description || res.data.message || '') : '' }); return; }
          var first = (Array.isArray(res.data.items) && res.data.items[0]) || res.data;
          resolve({ key: first && first.key ? String(first.key) : null });
        }, function () {
          if (done) return;
          done = true;
          clearTimeout(timer);
          reject({ message: '' });
        });
      });
    };
    var prev = cartChain || Promise.resolve();
    var p = prev.then(run, run);
    cartChain = p.then(function () { return null; }, function () { return null; });
    return p;
  }
  function openCart(key) {
    if (typeof window.openFlyoutCart === 'function') {
      try { window.openFlyoutCart({ addedKey: key }); return; } catch (e) { /* fall back */ }
    }
    var trig = document.querySelector('.flyout-trigger');
    if (trig) trig.click();
  }

  function mount(root) {
    if (!root || root.__bfp) return;
    root.__bfp = true;
    var cfg = readIsland(root, '[data-bfp-config]');
    if (!cfg) return;
    cfg.fits = Array.isArray(cfg.fits) ? cfg.fits : [];
    var mapped = cfg.fit_state === 'mapped';
    var index = indexMap(mapped ? readIsland(root, '[data-bfp-map]') : null);
    var products = (mapped && readIsland(root, '[data-bfp-products]')) || {};
    var money = function (cents) { return formatMoney(cents, cfg.money_format); };
    var state = { model: '', qty: 1, sets: null, replacing: null, busy: false };
    var live = qs(root, '[data-bfp-live]');
    var announce = function (msg) { if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 30); } };
    root.setAttribute('data-bfp-js', 'on');

    /* ---------- quantity, math line, Add to cart ---------- */
    var qtyInput = qs(root, '[data-bfp-qty]');
    var dec = qs(root, '[data-bfp-dec]');
    var inc = qs(root, '[data-bfp-inc]');
    var math = qs(root, '[data-bfp-math]');
    var status = qs(root, '[data-bfp-status]');
    var error = qs(root, '[data-bfp-error]');
    var form = qs(root, '[data-bfp-form]');
    var addBtn = qs(root, '[data-bfp-add]');
    var mbar = qs(root, '[data-bfp-mbar]');
    var mbarBtn = qs(root, '[data-bfp-mbar-add]');

    function renderQty() {
      if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = String(state.qty);
      if (dec) dec.disabled = state.qty <= 1;
      if (inc) inc.disabled = state.qty >= 999;
      show(math, state.qty > 1);
      if (state.qty > 1) setText(math, str('math', { qty: state.qty, price: money(cfg.price), total: money(cfg.price * state.qty) }));
      if (state.sets === null) renderSet();
    }
    function setQty(n) { state.qty = n; setText(status, ''); renderQty(); }
    if (dec) dec.addEventListener('click', function () { setQty(Math.max(1, state.qty - 1)); });
    if (inc) inc.addEventListener('click', function () { setQty(Math.min(999, state.qty + 1)); });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () { setQty(clampInt(qtyInput.value, 1, 999, 1)); });
      qtyInput.addEventListener('blur', function () { qtyInput.value = String(state.qty); });
    }
    function busy(buttons, on) {
      state.busy = on;
      buttons.forEach(function (b) {
        if (!b) return;
        var label = slot(b, 'label');
        if (on) { b.setAttribute('aria-busy', 'true'); if (label) { b.__bfpLabel = label.textContent; label.textContent = str('adding'); } }
        else { b.removeAttribute('aria-busy'); if (label && b.__bfpLabel != null) label.textContent = b.__bfpLabel; }
      });
    }
    function fail(box, e) { setText(box, (e && e.message) || str('add_failed')); show(box, true); }
    function addMain(trigger) {
      if (state.busy || !cfg.available) return;
      var qty = state.qty;
      show(error, false);
      setText(status, '');
      busy([addBtn, mbarBtn], true);
      cartAdd([{ id: cfg.variant_id, quantity: qty }]).then(function (res) {
        busy([addBtn, mbarBtn], false);
        setText(status, str('added', { qty: qty, sku: cfg.sku }));
        openCart(res.key);
      }, function (e) {
        busy([addBtn, mbarBtn], false);
        fail(error, e);
        if (trigger === mbarBtn && error && error.scrollIntoView) error.scrollIntoView({ block: 'center' });
      });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addMain(addBtn); });
    if (mbarBtn) mbarBtn.addEventListener('click', function () { addMain(mbarBtn); });

    /* ---------- phone sticky add bar: on once the main Add button has scrolled above the viewport ---------- */
    function pinnedHeader() {
      var v = 60;
      try { v = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--abi-pinned')) || 60; } catch (e) { v = 60; }
      return v;
    }
    function renderBar() {
      if (!mbar || !addBtn) return;
      var phone = window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : false;
      /* on: the main button is under the pinned header or above it, and the section still reaches the viewport's bottom
         edge (so the bar never sits over the site footer) */
      var on = phone && !!cfg.available && addBtn.getBoundingClientRect().bottom < pinnedHeader() && root.getBoundingClientRect().bottom > window.innerHeight;
      if (mbar.hidden === !on) return;
      mbar.hidden = !on;
      root.setAttribute('data-bfp-mbar', on ? 'on' : 'off');
    }
    if (mbar) {
      window.addEventListener('scroll', renderBar, { passive: true });
      window.addEventListener('resize', renderBar);
      /* a control focused under the bar is scrolled clear of it */
      root.addEventListener('focusin', function (e) {
        if (mbar.hidden || mbar.contains(e.target) || !e.target.getBoundingClientRect) return;
        var gap = e.target.getBoundingClientRect().bottom - (window.innerHeight - mbar.offsetHeight - 8);
        if (gap > 0) window.scrollBy(0, gap);
      });
    }

    /* ---------- contact links ---------- */
    function renderContact() {
      var m = state.model ? index.bySlug[state.model] : null;
      var href = contactHref(cfg, m ? m.name : '');
      qsa(root, '[data-bfp-contact]').forEach(function (a) { a.setAttribute('href', href); });
      return href;
    }

    if (!mapped) { renderQty(); renderContact(); renderBar(); return; }

    /* ---------- the model: ?model= wins, then the visit's stored model ---------- */
    var fitSlugs = cfg.fits.map(function (f) { return f.slug; });
    var input = qs(root, '[data-bfp-model-input]');
    var listbox = qs(root, '[data-bfp-listbox]');
    var nomatch = qs(root, '[data-bfp-nomatch]');
    var clearBtn = qs(root, '[data-bfp-clear]');
    var remember = qs(root, '[data-bfp-remember]');
    var combo = { open: false, active: 0, options: [], query: '' };
    var sideQuery = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;

    function storeModel(slug) {
      var s = sessionStore();
      try { if (s) { if (slug) s.setItem(cfg.model_key, slug); else s.removeItem(cfg.model_key); } } catch (e) { /* storage blocked */ }
    }
    (function initialModel() {
      var fromUrl = '';
      try { fromUrl = resolveModel(index, new window.URLSearchParams(window.location.search).get('model')); } catch (e) { fromUrl = ''; }
      if (fromUrl) { state.model = fromUrl; storeModel(fromUrl); return; }
      var s = sessionStore();
      try { state.model = resolveModel(index, s ? s.getItem(cfg.model_key) : ''); } catch (e) { state.model = ''; }
    })();

    /* ---------- combobox ---------- */
    function closeList() {
      combo.open = false;
      show(listbox, false);
      if (input) { input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); }
    }
    function renderList() {
      if (!listbox || !input) return;
      var res = matchModels(index, combo.query, fitSlugs, MAX_OPTIONS);
      combo.options = res.options;
      combo.active = Math.max(0, Math.min(combo.active, combo.options.length - 1));
      while (listbox.firstChild) listbox.removeChild(listbox.firstChild);
      combo.options.forEach(function (o, i) {
        var li = document.createElement('li');
        li.className = 'bfp-combo__opt';
        li.id = listbox.id + '-opt-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', i === combo.active ? 'true' : 'false');
        var name = document.createElement('span');
        name.className = 'bfp-combo__opt-name';
        name.textContent = o.name;
        li.appendChild(name);
        if (o.fits) {
          var tag = document.createElement('span');
          tag.className = 'bfp-combo__opt-tag';
          tag.textContent = str('opt_fits');
          li.appendChild(tag);
        }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(o.slug); });
        listbox.appendChild(li);
      });
      /* nothing matches: the list stays closed, and the line under the field (outside the listbox, so Tab reaches its
         link) says so until the text changes */
      var listOn = combo.open && combo.options.length > 0;
      show(nomatch, !combo.options.length && !!trim(combo.query));
      show(listbox, listOn);
      input.setAttribute('aria-expanded', listOn ? 'true' : 'false');
      if (listOn) input.setAttribute('aria-activedescendant', listbox.id + '-opt-' + combo.active);
      else input.removeAttribute('aria-activedescendant');
      if (listOn) {
        var act = listbox.children[combo.active];
        if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest' });
      }
      return res.total;
    }
    function openList(announceCount) {
      combo.open = true;
      var total = renderList();
      if (announceCount) announce(total === 1 ? str('count_one') : str('count', { n: total }));
    }
    function pick(slug) {
      state.model = slug;
      storeModel(slug);
      combo.query = '';
      combo.active = 0;
      show(nomatch, false);
      closeList();
      render();
      if (input) input.focus();
    }
    function clearModel() {
      state.model = '';
      storeModel('');
      combo.query = '';
      combo.active = 0;
      show(nomatch, false);
      closeList();
      render();
    }
    if (input) {
      input.addEventListener('input', function () {
        combo.query = input.value;
        combo.active = 0;
        if (state.model) { state.model = ''; render({ keepInput: true }); }
        if (!trim(input.value)) storeModel('');
        openList(true);
      });
      input.addEventListener('focus', function () { combo.query = state.model ? '' : input.value; openList(false); });
      input.addEventListener('click', function () { if (!combo.open) openList(false); });
      input.addEventListener('blur', function () { window.setTimeout(closeList, 120); });
      input.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown') { e.preventDefault(); if (!combo.open) { openList(false); return; } combo.active = Math.min(combo.active + 1, combo.options.length - 1); renderList(); }
        else if (k === 'ArrowUp') { e.preventDefault(); if (!combo.open) { openList(false); return; } combo.active = Math.max(combo.active - 1, 0); renderList(); }
        else if (k === 'Home' && combo.open) { e.preventDefault(); combo.active = 0; renderList(); }
        else if (k === 'End' && combo.open) { e.preventDefault(); combo.active = Math.max(combo.options.length - 1, 0); renderList(); }
        else if (k === 'Enter') { if (combo.open && combo.options[combo.active]) { e.preventDefault(); pick(combo.options[combo.active].slug); } }
        else if (k === 'Escape') { if (combo.open) { e.preventDefault(); closeList(); } }
        else if (k === 'Tab') { closeList(); }
      });
    }
    if (clearBtn) clearBtn.addEventListener('click', function () { clearModel(); if (input) input.focus(); });

    /* ---------- answer card, fit list ---------- */
    var answer = qs(root, '[data-bfp-answer]');
    function renderAnswer(contact) {
      if (!answer) return;
      var a = answerFor(cfg, index, state.model, sideQuery ? sideQuery.matches : true);
      answer.setAttribute('data-state', a.state);
      setText(slot(answer, 'mark'), a.mark);
      setText(slot(answer, 'title'), a.title);
      setText(slot(answer, 'sub'), a.sub);
      var link = slot(answer, 'link');
      show(link, !!a.link);
      if (link && a.link) {
        link.setAttribute('href', a.link.contact ? contact : a.link.href);
        setText(slot(link, 'link-text'), a.link.text);
      }
      qsa(root, '.bfp-fit__row').forEach(function (row) {
        if (state.model && row.getAttribute('data-model') === state.model) row.setAttribute('data-picked', 'true');
        else row.removeAttribute('data-picked');
      });
    }
    if (sideQuery) {
      var onSide = function () { renderAnswer(renderContact()); };
      if (sideQuery.addEventListener) sideQuery.addEventListener('change', onSide); else if (sideQuery.addListener) sideQuery.addListener(onSide);
    }

    /* ---------- filter version ---------- */
    var verSection = qs(root, '[data-bfp-versions]');
    var verList = qs(root, '[data-bfp-version-list]');
    function renderVersions() {
      if (!verSection || !verList) return;
      var model = state.model ? index.bySlug[state.model] : null;
      var fits = !!find(cfg.fits, function (f) { return f.slug === state.model; });
      var rows = model && fits ? versionRows(cfg, index, products, state.model) : [];
      show(verSection, rows.length > 1);
      while (verList.firstChild) verList.removeChild(verList.firstChild);
      if (rows.length < 2) return;
      var place = placeOf(model, cfg.sku);
      setText(slot(verSection, 'title'), str('ver_title', { role: lowerFirst(roleOf(place.stage)), model: model.name }));
      rows.forEach(function (r) {
        var li = clone(root, 'version');
        if (!li) return;
        if (r.here) li.setAttribute('data-here', 'true');
        setText(slot(li, 'label'), r.label);
        setText(slot(li, 'sku'), r.sku);
        setText(slot(li, 'cond'), r.cond);
        show(qs(li, '[data-bfp-v-here]'), r.here);
        show(slot(li, 'money'), r.buy);
        var price = slot(li, 'price');
        show(price, r.buy);
        if (r.buy) setText(price, money(r.price));
        var listRef = slot(li, 'list');
        show(listRef, r.buy && r.compare_at != null);
        if (r.buy && r.compare_at != null) setText(listRef, str('list_ref', { label: cfg.list_label, price: money(r.compare_at) }));
        var view = qs(li, '[data-bfp-v-view]');
        show(view, r.buy);
        if (r.buy) { view.setAttribute('href', r.href); view.setAttribute('aria-label', 'View this version: ' + r.label + ' ' + r.sku); }
        show(qs(li, '[data-bfp-v-quote]'), r.quote);
        var q = qs(li, '[data-bfp-v-quote-link]');
        show(q, r.quote);
        if (r.quote) { q.setAttribute('href', r.quoteHref); q.setAttribute('aria-label', 'Request a quote for ' + r.label + ' ' + r.sku); }
        verList.appendChild(li);
      });
    }

    /* ---------- complete the set ---------- */
    var setSection = qs(root, '[data-bfp-set]');
    var setEmpty = qs(root, '[data-bfp-set-empty]');
    var setBody = qs(root, '[data-bfp-set-body]');
    var setList = qs(root, '[data-bfp-set-list]');
    var setLeft = qs(root, '[data-bfp-set-left]');
    var setError = qs(root, '[data-bfp-set-error]');
    var currentSet = null;
    function setsValue() { return state.sets === null ? Math.min(99, state.qty) : state.sets; }
    function renderSetFoot() {
      if (!currentSet || !setList) return;
      var foot = qs(setList, '[data-bfp-set-foot]');
      if (!foot) return;
      var n = setsValue();
      var inputSets = qs(foot, '[data-bfp-sets]');
      if (inputSets && document.activeElement !== inputSets) inputSets.value = String(n);
      var d = qs(foot, '[data-bfp-sets-dec]');
      var i = qs(foot, '[data-bfp-sets-inc]');
      if (d) d.disabled = n <= 1;
      if (i) i.disabled = n >= 99;
      setText(slot(foot, 'total'), str('set_total', { sets: n === 1 ? str('set_one') : str('set_many', { n: n }), filters: str(currentSet.packs ? 'packs_many' : 'filters_many', { n: currentSet.lines.length * n }), total: money(currentSet.perSet * n) }));
      setText(slot(qs(foot, '[data-bfp-set-addall]'), 'label'), n === 1 ? str('add_set') : str('add_sets', { n: n }));
    }
    function renderSet() {
      if (!setSection || !setList) return;
      var s = sessionStore();
      var fits = !!find(cfg.fits, function (f) { return f.slug === state.model; });
      var set = state.model && fits ? setRows(cfg, index, products, state.model, readChoices(s, cfg.versions_prefix, state.model)) : null;
      /* keep the rows when only the quantity changed */
      if (set && currentSet && currentSet.model === set.model && qs(setList, '[data-bfp-set-row]')) { currentSet = set; renderSetFoot(); return; }
      currentSet = set;
      /* the section is the prompt (no model yet) or the set (a model this filter fits, with more than one stage);
         a model this filter does not fit, or a one-filter model, has no set to show */
      show(setSection, !state.model || !!set);
      show(setEmpty, !state.model);
      show(setBody, !!set);
      show(setError, false);
      setText(slot(setSection, 'title'), set ? str('set_title', { model: set.model.name }) : str('set_title_none'));
      while (setList.firstChild) setList.removeChild(setList.firstChild);
      if (!set) return;
      setText(slot(setBody, 'lead'), str(set.packs ? 'set_lead_packs' : 'set_lead', { model: set.model.name, n: set.stages }));
      var contact = contactHref(cfg, set.model.name);
      set.rows.forEach(function (r) {
        var li = clone(root, 'set-row');
        if (!li) return;
        li.setAttribute('data-kind', r.kind);
        var img = slot(li, 'img');
        if (img && r.image) { img.setAttribute('src', r.image); img.hidden = false; }
        setText(slot(li, 'stage'), r.stage);
        setText(slot(li, 'name'), r.name);
        show(slot(li, 'pn'), !!r.sku);
        setText(slot(li, 'sku'), r.sku);
        var spec = slot(li, 'spec');
        show(spec, !!r.spec);
        setText(spec, r.spec);
        var links = slot(li, 'links');
        show(links, r.links.length > 0);
        r.links.forEach(function (n, k) {
          if (k) links.appendChild(document.createTextNode(' · '));
          var a = document.createElement('a'); a.href = n.href; a.textContent = n.text; links.appendChild(a);
        });
        var note = slot(li, 'note');
        show(note, r.notes.length > 0);
        r.notes.forEach(function (n, k) {
          if (k) note.appendChild(document.createTextNode(' · '));
          if (n.href) { var a = document.createElement('a'); a.href = n.href; a.textContent = n.text; note.appendChild(a); }
          else note.appendChild(document.createTextNode(n.text));
        });
        var price = slot(li, 'price');
        var list = slot(li, 'list');
        show(price, r.price != null);
        if (r.price != null) {
          setText(price, money(r.price));
          show(list, r.compare_at != null);
          if (r.compare_at != null) setText(list, str('list_ref', { label: cfg.list_label, price: money(r.compare_at) }));
        }
        /* "in the set" only when this filter can go in the cart */
        show(qs(li, '[data-bfp-set-here]'), r.kind === 'here' && r.buy);
        var add = qs(li, '[data-bfp-set-add]');
        show(add, r.kind === 'buy');
        if (add && r.kind === 'buy') {
          add.setAttribute('aria-label', 'Add to cart: ' + r.name + ' ' + r.sku);
          add.addEventListener('click', function () { addRow(add, r, qs(li, '[data-bfp-set-rowerr]')); });
        }
        var view = qs(li, '[data-bfp-set-view]');
        show(view, r.kind === 'view');
        if (view && r.kind === 'view') { view.setAttribute('href', r.href); view.setAttribute('aria-label', 'View this filter: ' + r.name + ' ' + r.sku); }
        show(qs(li, '[data-bfp-set-choose]'), r.kind === 'choose');
        show(qs(li, '[data-bfp-set-quote]'), r.kind === 'quote' && !!r.quote);
        var q = qs(li, '[data-bfp-set-quote-link]');
        show(q, r.kind === 'quote' && !!r.quote);
        if (q && r.kind === 'quote' && r.quote) { q.setAttribute('href', r.quoteHref); q.setAttribute('aria-label', 'Request a quote for ' + r.name + ' ' + r.sku); }
        show(qs(li, '[data-bfp-set-unconf]'), r.kind === 'unconfirmed');
        var ask = qs(li, '[data-bfp-set-ask]');
        show(ask, r.kind === 'unconfirmed');
        if (ask && r.kind === 'unconfirmed') ask.setAttribute('href', contact);
        setList.appendChild(li);
      });
      if (set.lines.length > 1) {
        var foot = clone(root, 'set-foot');
        if (foot) {
          setList.appendChild(foot);
          var inputSets = qs(foot, '[data-bfp-sets]');
          var change = function (n) { state.sets = n; show(setError, false); renderSetFoot(); };
          qs(foot, '[data-bfp-sets-dec]').addEventListener('click', function () { change(Math.max(1, setsValue() - 1)); });
          qs(foot, '[data-bfp-sets-inc]').addEventListener('click', function () { change(Math.min(99, setsValue() + 1)); });
          inputSets.addEventListener('input', function () { change(clampInt(inputSets.value, 1, 99, 1)); });
          inputSets.addEventListener('blur', function () { inputSets.value = String(setsValue()); });
          var all = qs(foot, '[data-bfp-set-addall]');
          all.addEventListener('click', function () { addSet(all); });
        }
      }
      show(setLeft, set.left.length > 0);
      if (set.left.length) setText(setLeft, str('left_out', { list: set.left.map(leftText).join('; ') }));
      renderSetFoot();
    }
    function addRow(btn, row, errBox) {
      if (state.busy) return;
      show(errBox, false);
      busy([btn], true);
      cartAdd([{ id: row.variant_id, quantity: 1 }]).then(function (res) {
        busy([btn], false);
        announce(str('added', { qty: 1, sku: row.sku }));
        openCart(res.key);
      }, function (e) { busy([btn], false); fail(errBox, e); });
    }
    function addSet(btn) {
      if (state.busy || !currentSet) return;
      var n = setsValue();
      var model = currentSet.model;
      show(setError, false);
      busy([btn], true);
      cartAdd(setItems(currentSet, n)).then(function (res) {
        busy([btn], false);
        var msg = str('added_set', { sets: n === 1 ? str('set_one') : str('set_many', { n: n }), model: model.name });
        setText(status, msg);
        announce(msg);
        openCart(res.key);
      }, function (e) { busy([btn], false); fail(setError, e); });
    }

    /* ---------- replacing it ---------- */
    var rep = qs(root, '[data-bfp-rep]');
    function manualHref(slug) {
      var tpl = qs(root, 'template[data-bfp-manuals="' + slug + '"]');
      if (!tpl || !tpl.content) return '';
      var link = find(qsa(tpl.content, 'a[href]'), function (a) { return /manual/i.test(a.textContent || ''); });
      return link ? link.getAttribute('href') : '';
    }
    function renderReplacing() {
      if (!rep) return;
      var model = state.model ? index.bySlug[state.model] : null;
      var fits = !!find(cfg.fits, function (f) { return f.slug === state.model; });
      /* a model this filter doesn't fit: nothing here applies to it */
      if (state.model && !(model && fits)) { show(rep, false); return; }
      var r = replacingFor(state.replacing, model && fits ? model : null);
      /* the data file hasn't arrived (null) or didn't load (false): say nothing about the video rather than guess */
      if (r.state === 'model' && !state.replacing) { r.video = null; r.when = ''; r.cite = ''; r.none = ''; }
      var video = qs(rep, '[data-bfp-rep-video]');
      show(video, !!r.video);
      if (r.video) { video.setAttribute('href', r.video.href); setText(slot(video, 'video-title'), r.video.title); }
      var when = qs(rep, '[data-bfp-rep-when]');
      show(when, !!r.when);
      setText(when, r.when);
      var cite = qs(rep, '[data-bfp-rep-cite]');
      show(cite, !!r.cite);
      setText(cite, r.cite);
      var manual = qs(rep, '[data-bfp-rep-manual]');
      var href = r.state === 'model' ? manualHref(model.slug) : '';
      show(manual, !!href);
      if (href) { manual.setAttribute('href', href); setText(manual, r.manualLabel || (model.name + ' user manual (PDF)')); }
      var none = qs(rep, '[data-bfp-rep-none]');
      show(none, !!r.none);
      setText(slot(none, 'text'), r.none);
      show(qs(rep, '[data-bfp-rep-contact]'), r.state === 'model' && !!r.none);
      /* a model with no video, no guidance, no manual and no checked "no video" line: the panel has nothing to say */
      show(rep, r.state === 'pick' || !!r.video || !!r.when || !!href || !!r.none);
    }
    if (typeof window.fetch === 'function' && cfg.replacing_url) {
      window.fetch(cfg.replacing_url, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
        state.replacing = data && typeof data === 'object' ? data : false;
        renderReplacing();
      }, function () { state.replacing = false; renderReplacing(); });
    } else state.replacing = false;

    /* ---------- everything that follows the picked model ---------- */
    function render(opts) {
      var model = state.model ? index.bySlug[state.model] : null;
      if (input && !(opts && opts.keepInput)) input.value = model ? model.name : '';
      show(clearBtn, !!model || !!(input && input.value));
      setText(remember, model ? str('remember_set', { model: model.name }) : str('remember_none'));
      var contact = renderContact();
      renderAnswer(contact);
      renderVersions();
      state.sets = null;
      currentSet = null;
      renderSet();
      renderReplacing();
    }
    renderQty();
    render();
    renderBar();
  }

  return {
    mount: mount, norm: norm, fill: fill, formatMoney: formatMoney, clampInt: clampInt, indexMap: indexMap, resolveModel: resolveModel,
    matchModels: matchModels, placeOf: placeOf, answerFor: answerFor, versionRows: versionRows, setRows: setRows, setItems: setItems,
    readChoices: readChoices, replacingFor: replacingFor, contactHref: contactHref, quoteHref: quoteHref, shortLabel: shortLabel,
    roleOf: roleOf, lowerFirst: lowerFirst, sentence: sentence, stageLabel: stageLabel, leftText: leftText, isPack: isPack, STR: STR
  };
});
